/**
 * Where this build talks to.
 *
 * The value is injected at build time by `preact.config.js` from
 * `API_PROXY_BASE_URL`, which is read from `.env.production`, `.env.staging` or
 * `.env` depending on how the build was invoked. It already includes the `/api`
 * prefix, so call sites append the path only.
 *
 * There is deliberately no fallback. Defaulting to production would mean a
 * misconfigured staging build quietly books real appointments onto real charts
 * while calling itself a test environment — the exact failure this module
 * exists to prevent. A missing value fails the build (see `preact.config.js`),
 * and this guard covers anything that reaches the browser without one.
 */
const API_BASE_URL = process.env.API_PROXY_BASE_URL;

if (!API_BASE_URL) {
  throw new Error(
    "API_PROXY_BASE_URL is not set. This build has no API host and cannot run. " +
      "Check that the .env file for this environment defines it."
  );
}

export { API_BASE_URL };
